const GET_SAVED_PAYMENT_METHODS = (state) => {
  state.savedPaymentMethods = null
  state.savedPaymentMethodsLoading = true
}

const SET_PAYMENT_METHODS_FILTER = (state, filter) => {
  state.paymentMethodsFilter = filter
}

const SET_SAVED_PAYMENT_METHODS = (state, methods) => {
  state.savedPaymentMethods = methods
  state.savedPaymentMethodsLoading = false
  state.loadingOrderAndPayment = false
}

const SET_SAVED_PAYMENT_METHODS_LEGACY = (state, methods) => {
  state.savedPaymentMethodsLegacy = methods
  state.savedPaymentMethodsLoading = false
  state.loadingOrderAndPayment = false
}

const SET_PAYMENT_METHODS_LEGACY = (state, methods) => {
  state.paymentMethodsLegacy = methods
}

const SET_AUTO_PURCHASE = (state, value) => {
  state.autoPurchase = value
}

const SET_3D_SECURE_CHALLANGE = (state, data) => {
  state.order3DSChallange = data // providerData
}

const SET_SELECTED_PAYMENT_METHOD = (state, method) => {
  state.selectedPaymentMethod = method
}

const ADD_NEW_PAYMENT_METHOD = (state) => {
  state.addNewPaymentMethod = true
}

const VIEW_SAVED_PAYMENT_METHOD = (state) => {
  state.addNewPaymentMethod = false
}

const VALIDATE_ORDER = (state, data) => {
  state.order = false
  state.orderState = 'WAITING_FOR_VALIDATION'
  state.orderErrorMessage = null
  state.orderErrorType = null
  state.selectedPaymentMethod = null
  state.savedPaymentMethodsLegacy = null
  state.savedPaymentMethods = null
  state.paymentMethodsLegacy = null
  state.order3DSChallange = null
  state.orderWelcomeOfferMessage = null
  state.loadingOrderAndPayment = true
}

const SET_ORDER_TYPE = (state, type) => {
  state.orderType = type
}

const SET_ORDER_ERROR = (state, type) => {
  state.orderState = 'ERROR'
  state.orderErrorType = type
}

const SET_WELCOME_OFFER_ERROR_MESSAGE = (state, error) => {
  state.orderWelcomeOfferMessage = [error]
}

const SET_ORDER_RESPONSE_ERROR = (state, data) => {
  state.orderState = 'ERROR'
  state.orderErrorType = data.type
  state.loadingOrderAndPayment = false

  if (data.result && typeof data.result.errors === 'object') {
    let errors = data.result.errors
    // TODO test with real GraphQL errors - talk to backend how that can be tested better
    if (errors.length > 0) {
      state.orderErrorMessage = []
      for (var error in errors) {
        if (errors[error].extensions && errors[error].extensions.userMessage) {
          state.orderErrorMessage.push(errors[error].extensions.userMessage)
        }
      }
    }
  } else if (data.result && data.result.message) {
    state.orderErrorMessage = [data.result.message]
  } else if (data.message) {
    state.orderErrorMessage = [data.message]
  }
}
const SET_GRAPHQL_RESPONSE_ERROR = (state, data) => {
  state.orderState = 'ERROR'
  state.orderErrorType = data.type
  state.loadingOrderAndPayment = false
  if (data.result && data.result.response && data.result.response.data && data.result.response.data.errors) {
    const errorArray = data.result.response.data.errors
    if (errorArray.length > 0) {
      state.orderErrorMessage = []
      for (var error in errorArray) {
        if (errorArray[error].message) {
          state.orderErrorMessage.push(errorArray[error].message)
        }
      }
    }
  }
}
const SET_ORDER = (state, result) => {
  state.order = result.data.orders.createAndValidateOrder.order
  state.orderState = result.data.orders.createAndValidateOrder.order.state
}

const SET_REBTEL_CREDITS_ORDER = (state, result) => {
  state.order = result.data.orders.useCreditBalance.order
  state.orderState = result.data.orders.useCreditBalance.order.state
}

const SET_REMOVE_REBTEL_CREDITS_ORDER = (state, result) => {
  state.order = result.data.orders.removeCreditBalance.order
  state.orderState = result.data.orders.removeCreditBalance.order.state
}

const SET_PREBOOKING = (state, result) => {
  // map the result here and set order and orderState
  const tempItemForMapping = {
    product: result.product,
    destination: result.destination,
    productId: result.product.id
  }
  const prebooking = {
    createdAt: result.nextExecutionTime,
    id: result.id,
    items: [tempItemForMapping],
    paymentOptions: result.paymentOptions,
    state: result.state,
    summary: {...result.summary, vats: [result.summary.vat]}
  }
  state.order = prebooking
  state.orderState = result.state
}
const REMOVE_ORDER_INFO = (state) => {
  state.order = null
  state.orderState = null
}
const SET_PREBOOK_INFO = (state, data) => {
  state.prebookingInfo = data
}
const SET_PREBOOK_PAYMENT_INFO = (state, data) => {
  state.prebookingPaymentInfo = data
}

const SUBMIT_ORDER = (state) => {
  state.orderState = 'SUBMITTED'
  state.addNewPaymentMethod = false
}

const SET_PAYMENT_DATA_LOADING = (state) => {
  state.paymentDataLoaded = false
}

const SET_PAYMENT_DATA_LOADED = (state) => {
  state.paymentDataLoaded = true
}

const SUBMIT_3D_SECURE_DATA = (state) => {
  state.orderState = 'SUBMITTED_3D_SECURE'
}

const ORDER_SUBMIT_RESPONSE_SUCCESS = (state, response) => {
  if (state.order) state.order.response = response
  state.orderStateChecks = 0
}
const SET_USERS_SUBSCRIPTION = (state, subscription) => {
  // SUBSCRIPTION ALWAYS PART OF THE ORDER FLOW. NO ORDER NO SUBSCRIPTION FLOW
  if (state.order) state.order.existedSubscriptionsOfUser = subscription
}
const SET_CREATED_SUBSCRIPTION_FREQUENCY = (state, data) => {
  // SUBSCRIPTION ALWAYS PART OF THE ORDER FLOW. NO ORDER NO SUBSCRIPTION FLOW
  if (state.order) state.order.createdSubscriptionFrequency = data.subscription.frequency
}
const ORDER_STATE_CHECK_COUNTER_INCREASE = (state, error) => {
  state.orderStateChecks += 1
}

const SET_ORDER_STATE = (state, data) => {
  state.orderState = data
}
const SET_LAST_USED_PAYMENT_METHOD_ID = (state, data) => {
  state.lastUsedPaymentMethodId = data
}

// Sets the orders in progress - used for Account Activity
const SET_ORDERS_IN_PROGRESS = (state, data) => {
  state.ordersInProgress = data
}

const SET_LEGACY_ORDER = (state, data) => {
  data.legacy = true
  state.order = data
  state.orderState = 'VALIDATED'
}

const LEGACY_ORDER_SUBMIT_RESPONSE_SUCCESS = (state, response) => {
  if (state.order) state.order.response = response
  state.order.id = response.id
  state.orderStateChecks = 0
}
const SET_PRODUCT_IS_AVAILABLE_FOR_SUBSCRIPTION = (state) => {
  state.order.isProductAvailableForSubscription = true
}
const SET_SUBSCRIPTION_DATA_LOADED = (state) => {
  state.topupSubscriptionDataLoaded = true
}
const SET_SUBSCRIPTION_DATE = (state, data) => {
  if (state.order) state.order.subscriptionDate = data.subscription.nextExecutionTime
}
const SET_SUBSCRIPTION_FREQUENCY_OPTIONS = (state, data) => {
  if (state.order) state.order.subscriptionFrequencyOptions = data
}
const SET_SUBSCRIPTION_ID = (state, data) => {
  if (state.order) state.order.subscriptionId = data.id
}

const SET_SUBSCRIPTION_STATE = (state, data) => {
  if (state.order) state.subscriptionState = data
}
const PRESET_SUBSCRIPTION_FREQUENCY = (state, data) => {
  state.preSelectedTopupSubscriptionFrequency = data
  state.subscriptionState = 'PRE-SELECTED'
}
const RESET_SUBSCRIPTION = (state) => {
  if (state.order) {
    state.order.subscriptionDate = null
    state.order.isProductAvailableForSubscription = false
    state.order.existedSubscriptionsOfUser = null
    state.order.savedMethodIdForSubscription = null
    state.order.createdSubscriptionFrequency = null
  }
  state.topupSubscriptionDataLoaded = false
  state.preSelectedTopupSubscriptionFrequency = null
  state.subscriptionState = 'NONE'
}
const SET_PAYMENT_METHOD_ID_FOR_SUBSCRIPTION = (state, data) => {
  if (state.order) state.order.savedMethodIdForSubscription = data
}
export default {
  GET_SAVED_PAYMENT_METHODS,
  SET_SAVED_PAYMENT_METHODS,
  SET_PAYMENT_METHODS_FILTER,
  SET_SAVED_PAYMENT_METHODS_LEGACY,
  SET_PAYMENT_METHODS_LEGACY,
  SET_SELECTED_PAYMENT_METHOD,
  ADD_NEW_PAYMENT_METHOD,
  VIEW_SAVED_PAYMENT_METHOD,
  VALIDATE_ORDER,
  SET_PAYMENT_DATA_LOADING,
  SET_PAYMENT_DATA_LOADED,
  SUBMIT_ORDER,
  SUBMIT_3D_SECURE_DATA,
  SET_AUTO_PURCHASE,
  SET_3D_SECURE_CHALLANGE,
  SET_ORDER_RESPONSE_ERROR,
  SET_ORDER_ERROR,
  SET_ORDER,
  SET_ORDER_TYPE,
  SET_ORDERS_IN_PROGRESS,
  ORDER_STATE_CHECK_COUNTER_INCREASE,
  ORDER_SUBMIT_RESPONSE_SUCCESS,
  LEGACY_ORDER_SUBMIT_RESPONSE_SUCCESS,
  SET_ORDER_STATE,
  SET_LEGACY_ORDER,
  SET_WELCOME_OFFER_ERROR_MESSAGE,
  SET_PREBOOK_INFO,
  SET_GRAPHQL_RESPONSE_ERROR,
  SET_PREBOOK_PAYMENT_INFO,
  REMOVE_ORDER_INFO,
  SET_PREBOOKING,
  SET_USERS_SUBSCRIPTION,
  SET_PRODUCT_IS_AVAILABLE_FOR_SUBSCRIPTION,
  SET_SUBSCRIPTION_DATE,
  SET_SUBSCRIPTION_STATE,
  RESET_SUBSCRIPTION,
  SET_SUBSCRIPTION_FREQUENCY_OPTIONS,
  SET_PAYMENT_METHOD_ID_FOR_SUBSCRIPTION,
  SET_SUBSCRIPTION_ID,
  SET_SUBSCRIPTION_DATA_LOADED,
  PRESET_SUBSCRIPTION_FREQUENCY,
  SET_CREATED_SUBSCRIPTION_FREQUENCY,
  SET_LAST_USED_PAYMENT_METHOD_ID,
  SET_REBTEL_CREDITS_ORDER,
  SET_REMOVE_REBTEL_CREDITS_ORDER
}



// WEBPACK FOOTER //
// ./src/store/modules/checkout-v2/mutations.js